import { useSetupFooter } from "views/Setup/context/SetupFooterContext";
import { useIdentityForm } from "../../hooks/useIdentityForm";
import HeadOfficeAddressForm from "./HeadOfficeAddressForm";
import useFooterStore from "views/hooks/useFooterStore";
import { ApolloQueryResult } from "@apollo/client";
import CompanyInfoForm from "./CompanyInfoForm";
import ContactInfoForm from "./ContactInfoForm";
import { useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import Loading from "components/Loading";
import { Form, Row } from "antd";

interface IdentityProps {
  mainAddress?: ListAddressesCompanyResult;
  nextButton?: () => void;
  prevButton?: () => void;
  isSetup?: boolean;
  loading?: boolean;
  refetch?: (
    variables?: Partial<GetVarTypeID> | undefined,
  ) => Promise<ApolloQueryResult<GetCompanyResponse>>;
}

export default function Identity({
  mainAddress,
  nextButton,
  isSetup,
  loading,
  refetch,
}: IdentityProps): React.ReactElement {
  const location = useLocation();
  const tabName = location.pathname.split("/").pop();

  const { handleOkSaveButton, setHandleOkSaveButton, setSaveLoading } = useFooterStore();

  const { form, onFinish, onValuesChange, handleVatNumberChange } = useIdentityForm(
    mainAddress,
    nextButton,
    isSetup,
    refetch,
  );
  const vatNumberValue = Form.useWatch("vatNumber", form);

  useEffect(() => {
    handleVatNumberChange(vatNumberValue);
  }, [vatNumberValue]);

  useEffect(() => {
    if (handleOkSaveButton && tabName === "identity" && !isSetup) {
      form.submit();
      setSaveLoading(true);
    }
  }, [handleOkSaveButton, tabName, isSetup]);

  const onFinishFailed = ({
    errorFields,
  }: {
    errorFields: { name: (string | number)[]; errors: string[] }[];
  }) => {
    if (errorFields) {
      setHandleOkSaveButton(false);
      setSaveLoading(false);
    }
  };

  const handleSaveAndNext = () => {
    setSaveLoading(true);
    form.submit();
  };

  useSetupFooter(isSetup ? { onSave: handleSaveAndNext, loading } : null);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Form
          name="updateCompanyAddress"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          onValuesChange={onValuesChange}
          autoComplete="off"
        >
          <Row gutter={[16, 16]}>
            <CompanyInfoForm />
            <HeadOfficeAddressForm />
            <ContactInfoForm />
          </Row>
        </Form>
      )}
    </>
  );
}
